export default "__VITE_ASSET__BcAsAT0V__"